function ButtonRadio({ htmlFor, id, name, className, label, onChange, value, checked, disabled }) {
    return (
        <div className="button-radio flex gap-1 items-center">
            <input
                type="radio"
                id={id}
                name={name}
                value={value}
                checked={checked}
                onChange={onChange}
                disabled={disabled}
                className="
                w-4
                h-4
                text-primary
                border-input
                rounded-full
                checked:border-primary
                focus:ring-2
                focus:outline-none
                focus:ring-primary/20
                border
                cursor-pointer
                "
            />

            <label htmlFor={htmlFor} className={"text-sm text-foreground/80 " + className}>{label}</label>

        </div>
    )
}

export default ButtonRadio;